import { z } from 'zod';

export const FormFieldOptionDTO = z.object({
    label: z.string(),
    value: z.string(),
    selected: z.boolean(),
});

export const FormFieldDTO = (idFieldDTO: z.ZodTypeAny) =>
    z.object({
        id: idFieldDTO,
        type: z.string(),
        isRequired: z.boolean(),
        required: z.boolean().optional(),
        default: z.string().optional(),
        maxLength: z.number().optional(),
        options: z.array(FormFieldOptionDTO).optional(),
    });

export const FormsByTypeDTO = (idFieldDTOs: z.ZodTypeAny[]) => {
    const fieldSchemas = idFieldDTOs.map(FormFieldDTO);

    return z.object({
        fields: z.array(z.union([fieldSchemas[0], fieldSchemas[1], ...fieldSchemas.slice(2)])),
    });
};

export type FormsByTypeContainerDTO = z.infer<typeof FormsByTypeContainerDTO>;

export const FormsByTypeContainerDTO = z.object({
    form: z.unknown(),
});
